import React, { useContext } from "react";
import { Input, makeStyles } from "@material-ui/core";
import { Field, ErrorMessage } from "formik";
import FormError from "../FormError";

import FMUInputField from "../../components/shared/FormIkMUFormComponent/FMUInputField";
import { Typography } from "@material-ui/core";
import { viewportContext } from "../../context/ViewportContext";
import { tokens } from "../../theme/tokens";

// The J10 Field visual contract, expressed for this copy's v4 <Input>.
// (This is a separate v4 implementation of the same appearance — the fork is
// intentionally not merged, per the ticket.)
const fieldLook = {
  width: "100%",
  height: "40px",
  paddingLeft: "3px",
  backgroundColor: tokens.color.surface.default,
  border: `${tokens.borderWidth} solid ${tokens.color.border.default}`,
  borderRadius: tokens.radius.sm,
  transition: `border-color ${tokens.motion.fast} ${tokens.motion.easing}`,
  "&:hover": { borderColor: tokens.color.border.strong },
  "&.Mui-focused": { borderColor: tokens.color.focus.ring },
  "& .MuiInputBase-input": {
    textIndent: "10px",
    color: tokens.color.text.primary,
    fontSize: tokens.type.dense.size,
  },
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: tokens.color.text.disabled,
  },
};

const useStyles = makeStyles(() => ({
  parentChild: {
    height: "50px",
    flex: "1",
    width: "100%",
    "&:nth-child(1)": {
      paddingRight: "5vh",
    },
    "&:nth-child(2)": {
      paddingLeft: "5vh",
    },
  },
  parentChildTallScreen: {
    height: "50px",
    flex: "1",
    width: "100%",
  },
  rowContainer: {
    display: "flex",
    marginTop: "8px",
  },
  labelContainer: {
    display: "flex",
    width: "50%",
    alignItems: "center",
    "& p": {
      fontSize: tokens.type.body.size,
      color: tokens.color.text.primary,
    },
  },
  fieldContainer: {
    width: "50%",
  },
  input: { ...fieldLook },
  emailInput: { ...fieldLook },
  dateInput: {
    ...fieldLook,
    "& .MuiInputBase-input": {
      ...fieldLook["& .MuiInputBase-input"],
      textIndent: "12px",
    },
  },
  error: {
    fontSize: tokens.type.caption.size,
    color: tokens.color.status.error,
    marginTop: "0.25rem",
    paddingLeft: "50%",
  },
}));
function NewCaseField({
  label,
  name,
  type,
  disabled,
  placeHolder,
  isEmail,
  required,
  input,
  customOnChange,
  style,
}) {
  const { tallScreen } = useContext(viewportContext);
  const handleOnChange = (e) => {
    return customOnChange(e);
  };
  const classes = useStyles();
  return (
    <div
      className={
        tallScreen ? classes.parentChildTallScreen : classes.parentChild
      }
    >
      <div className={classes.rowContainer}>
        <div className={classes.labelContainer}>
          {required ? (
            <Typography>
              {label}
              <span
                style={{ color: tokens.color.status.error, fontWeight: 500 }}
              >
                *
              </span>
            </Typography>
          ) : (
            <Typography>{label}</Typography>
          )}
        </div>
        <div className={classes.fieldContainer}>
          {input ? (
            <Input
              name={name}
              type={type}
              disabled={disabled}
              fullwidth={"true"}
              onChange={handleOnChange}
              disableUnderline={true}
              className={
                isEmail
                  ? classes.emailInput
                  : type === "date"
                    ? classes.dateInput
                    : classes.input
              }
              label={placeHolder ? placeHolder : label}
            />
          ) : (
            <Field
              name={name}
              type={type}
              disabled={disabled}
              fullwidth={"true"}
              style={style}
              disableUnderline={true}
              className={
                isEmail
                  ? classes.emailInput
                  : type === "date"
                    ? classes.dateInput
                    : classes.input
              }
              component={FMUInputField}
              label={placeHolder ? placeHolder : label}
            />
          )}
        </div>
      </div>
      <div>
        <ErrorMessage
          name={name}
          component={FormError}
          className={classes.error}
        />
      </div>
    </div>
  );
}

export default NewCaseField;
